import React from 'react';
import FAQ from '../components/FAQ';

const FAQPage = () => {
  return (
    <>
      <FAQ />
    </>
  );
};

export default FAQPage;
